
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3(032|597|614|862)|(138|427|506|853)8|1903|2609|2977|4121|6314|6942|7022|8345)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
